<template>
  <div class="content px-4">
    <PulseLoader :loading="loading" :class="{ hide: !loading }" quote="Action is the foundational key to all success"
      author="Pablo Picasso" profession="Spanish Painter" img="picasso.jpg"></PulseLoader>
    <div class="md-layout">
      <div class="md-layout-item">
        <nav aria-label="breadcrumb" role="navigation" class="m-0">
          <ol class="breadcrumb py-4">
            <li class="breadcrumb-item">
              Home
            </li>
            <li class="breadcrumb-item active" aria-current="page">
              My Account
            </li>
          </ol>
        </nav>
      </div>
    </div>
    <!-- <pulse-loader
      class="loading"
      :color="'blue'"
      :loading="loading"
    ></pulse-loader>-->
    <div class="md-layout">
      <div class="md-layout-item">
        <h1 class="section_header small_screen">My Account</h1>
      </div>
    </div>
    <form v-if="!loading" @submit.prevent="saveAll($event)" enctype="multipart/form-data">
      <div class="md-layout my_account">
        <div class="md-layout-item md-medium-size-100 md-size-100 p-0">
          <md-tooltip md-direction="top" class="width-tooltip" v-if="showTooltip">Upgrade to a subscription to access this
            feature</md-tooltip>
          <nav-tabs-card no-label md-elevation="0" class="m-0">
            <template slot="content">
              <md-tabs md-alignment="left">
                <md-tab id="my_profile" md-label="My Profile" class="p-0">
                  <md-card id="tst" class="account_info">
                    <h2>My Profile</h2>
                    <md-card-header>
                      <div class="md-card-avatar">
                        <span @click="$refs.imgUpload.click()">
                          <avatar class="user-avatar" v-if="!avatar" :rounded="false" :size="120" :inline="true"
                            backgroundColor="#133a64" :username="firstname + ' ' + lastname"></avatar>
                        </span>
                        <img v-if="avatar" alt="User avatar image" class="img" :src="avatar"
                          @click="$refs.imgUpload.click()" />
                        <div class="edit-user-avatar back-ground-dark-blue" @click="$refs.imgUpload.click()">
                          <md-icon>edit</md-icon>
                        </div>
                        <input aria-label="Avatar file edit" style="display:none" type="file" name="avatar"
                          @change="onFileChange" ref="imgUpload" />
                      </div>
                      <div class="avatar_info">
                        <h2 class="card-title">
                          {{ firstname ? firstname : "" }}
                          {{ lastname ? lastname : "" }}
                        </h2>
                        <p class="category text-gray">{{ this.myTitle }}</p>
                      </div>
                    </md-card-header>
                    <md-card-content>
                      <div class="form_Wrapper">
                        <div class="md-layout">
                          <div class="md-layout-item md-small-size-100 md-size-100">
                            <div class="section-title">Account Information</div>
                          </div>
                          <div class="md-layout-item md-small-size-100 md-medium-size-100 md-size-50">
                            <md-field :class="{
                              'md-invalid': $v.billingemailAddress.$error,
                            }">
                              <label>
                                Email
                                <i class="md-icon">help</i>
                              </label>
                              <md-input v-model="$v.billingemailAddress.$model" type="text"></md-input>
                              <span class="md-error" v-if="!$v.billingemailAddress.required">This field is
                                required.</span>
                              <span class="md-error" v-if="!$v.billingemailAddress.email">You must input email.</span>
                            </md-field>
                          </div>
                          <div class="md-layout-item md-small-size-100 md-size-50">
                            <md-field :class="{
                              'md-invalid': $v.billingFirstname.$error,
                            }">
                              <label for="first-name">
                                First Name
                                <i class="md-icon">help</i>
                              </label>
                              <md-input id="first-name" v-model="$v.billingFirstname.$model" type="text"></md-input>
                              <span class="md-error" v-if="!$v.billingFirstname.required">This field is required.</span>
                            </md-field>
                          </div>
                          <div class="md-layout-item md-small-size-100 md-size-50">
                            <md-field :class="{
                              'md-invalid': $v.billingLastname.$error,
                            }">
                              <label for="last-name">
                                Last Name
                                <i class="md-icon">help</i>
                              </label>
                              <md-input id="last-name" v-model="$v.billingLastname.$model" type="text"></md-input>
                              <span class="md-error" v-if="!$v.billingLastname.required">This field is required.</span>
                            </md-field>
                          </div>
                          <div class="md-layout-item md-small-size-100 md-size-100">
                            <div class="section-title">Billing Information</div>
                          </div>
                          <div class="md-layout-item md-small-size-100 md-medium-size-50 md-size-33">
                            <md-field :class="{
                              'md-invalid': $v.firstname.$error,
                            }">
                              <label for="billing-first-name">
                                Billing First Name
                                <i class="md-icon">help</i>
                              </label>
                              <md-input id="billing-first-name" v-model="$v.firstname.$model" type="text"></md-input>
                              <span class="md-error" v-if="!$v.firstname.required">This field is required.</span>
                            </md-field>
                          </div>
                          <div class="md-layout-item md-small-size-100 md-medium-size-50 md-size-33">
                            <md-field :class="{
                              'md-invalid': $v.lastname.$error,
                            }">
                              <label for="billing-last-name">
                                Billing Last Name
                                <i class="md-icon">help</i>
                              </label>
                              <md-input id="billing-last-name" v-model="$v.lastname.$model" type="text"></md-input>
                              <span class="md-error" v-if="!$v.lastname.required">This field is required.</span>
                            </md-field>
                          </div>
                          <div class="md-layout-item md-small-size-100 md-medium-size-50 md-size-33">
                            <md-field :class="{
                              'md-invalid': $v.emailAddress.$error,
                            }">
                              <label for="billing-email">
                                Billing Email
                                <i class="md-icon">help</i>
                              </label>
                              <md-input id="billing-email" v-model="$v.emailAddress.$model" type="email"></md-input>
                              <span class="md-error" v-if="!$v.emailAddress.required">This field is required.</span>
                              <span class="md-error" v-if="!$v.emailAddress.email">You must input email.</span>
                            </md-field>
                          </div>
                          <div class="md-layout-item md-small-size-100 md-size-100">
                            <div class="section-title">Other Information</div>
                          </div>
                          <div class="md-layout-item md-small-size-100 md-medium-size-50 md-size-33">
                            <md-field :class="{ 'md-invalid': $v.phoneNumber.$error }">
                              <label for="phone-number">Phone Number</label>
                              <md-input id="phone-number" v-model="$v.phoneNumber.$model" type="text"></md-input>
                              <span class="md-error" v-if="!$v.phoneNumber.required">This field is required.</span>
                            </md-field>
                          </div>
                          <div class="md-layout-item md-small-size-100 md-medium-size-50 md-size-33">
                            <md-field :class="{ 'md-invalid': $v.address.$error }">
                              <label for="street-adress">Street Adress</label>
                              <md-input id="street-adress" v-model="$v.address.$model" type="text"></md-input>
                              <span class="md-error" v-if="!$v.address.required">This field is required.</span>
                            </md-field>
                          </div>
                          <div class="md-layout-item md-small-size-100 md-medium-size-50 md-size-33">
                            <md-field :class="{ 'md-invalid': $v.city.$error }">
                              <label for="city">City</label>
                              <md-input id="city" v-model="$v.city.$model" type="text"></md-input>
                              <span class="md-error" v-if="!$v.city.required">This field is required.</span>
                            </md-field>
                          </div>
                          <div class="md-layout-item md-small-size-100 md-medium-size-50 md-size-33">
                            <md-field :class="{ 'md-invalid': $v.country.$error }">
                              <label for="country-select-label">Country</label>
                              <country-select id="country-select-label" v-model="country" :country="country"
                                topCountry="US" />
                              <span class="md-error" v-if="!$v.country.required">This field is required.</span>
                            </md-field>
                          </div>
                          <div class="md-layout-item md-small-size-100 md-medium-size-50 md-size-33">
                            <md-field :class="{ 'md-invalid': $v.stateProvince.$error }">
                              <label for="state-province">State/Province</label>
                              <region-select id="state-province" v-model="$v.stateProvince.$model" :country="country"
                                :region="region" />
                              <span class="md-error" v-if="!$v.stateProvince.required">This field is required.</span>
                            </md-field>
                          </div>
                          <div class="md-layout-item md-small-size-100 md-medium-size-50 md-size-33">
                            <md-field :class="{ 'md-invalid': $v.code.$error }">
                              <label>Zip/Postal Code</label>
                              <md-input v-model="$v.code.$model"></md-input>
                              <span class="md-error" v-if="!$v.code.required">This field is required.</span>
                            </md-field>
                          </div>
                          <!-- <country-select
                            v-model="country"
                            :country="country"
                            topCountry="US"
                          />-->
                          <!-- <region-select
                            v-model="region"
                            :country="country"
                            :region="region"
                          />-->
                        </div>
                      </div>
                      <div class="text-right saveBtn">
                        <md-button @click="tabType = 'My Profile'" type="submit"
                          class="md-raised md-info md-round mt-4 dark-blue-color">Save Changes</md-button>
                      </div>
                    </md-card-content>
                  </md-card>
                </md-tab>
                <md-tab id="my_company" md-label="My Company" class="p-0">
                  <md-card class="account_info">
                    <h1>My Company</h1>
                    <md-card-header>
                      <div class="md-card-avatar">
                        <span @click="$refs.imgUpload.click()">
                          <avatar class="user-avatar" v-if="!avatar" :rounded="false" :size="120" :inline="true"
                            backgroundColor="#133a64" :username="firstname + ' ' + lastname"></avatar>
                        </span>
                        <img v-if="avatar" alt="User avatar image" class="img" :src="avatar"
                          @click="$refs.imgUpload.click()" />
                        <div class="edit-user-avatar" @click="$refs.imgUpload.click()">
                          <md-icon class="dark-blue-back-ground-color-side-bar">edit</md-icon>
                        </div>
                        <input aria-label="Avatar" style="display:none" type="file" name="avatar" @change="onFileChange"
                          ref="imgUpload" />
                      </div>
                      <div class="avatar_info">
                        <h2 class="card-title">
                          {{ firstname ? firstname : "" }}
                          {{ lastname ? lastname : "" }}
                        </h2>
                        <p class="category text-gray">{{ this.myTitle }}</p>
                      </div>
                    </md-card-header>
                    <md-card-content>
                      <div class="form_Wrapper">
                        <div class="md-layout">
                          <div class="md-layout-item md-small-size-100 md-size-100">
                            <div class="section-title">Company Information</div>
                          </div>
                          <div class="md-layout-item md-small-size-100 md-size-50">
                            <md-field>
                              <label>
                                Company Name
                                <i class="md-icon">help</i>
                              </label>
                              <md-input v-model="companyName" type="text"></md-input>
                            </md-field>
                          </div>
                          <div class="md-layout-item md-small-size-100 md-size-50">
                            <md-field>
                              <label>
                                Company Address
                                <i class="md-icon">help</i>
                              </label>
                              <md-input v-model="companyAddress" type="text"></md-input>
                            </md-field>
                          </div>
                          <div class="md-layout-item md-small-size-100 md-size-50">
                            <md-field>
                              <label>
                                Company City
                                <i class="md-icon">help</i>
                              </label>
                              <md-input v-model="companyCity" type="text"></md-input>
                            </md-field>
                          </div>
                          <div class="md-layout-item md-small-size-100 md-size-50">
                            <md-field>
                              <label>
                                Company Country
                                <i class="md-icon">help</i>
                              </label>
                              <country-select aria-label="Company country" v-model="companyCountry"
                                :country="companyCountry" topCountry="US" />
                            </md-field>
                          </div>
                          <div class="md-layout-item md-small-size-100 md-size-50">
                            <md-field>
                              <label>
                                Company State
                                <i class="md-icon">help</i>
                              </label>
                              <region-select aria-label="Company state" v-model="companyState" :country="companyCountry"
                                :region="companyState" />
                            </md-field>
                          </div>
                          <div class="md-layout-item md-small-size-100 md-size-50">
                            <md-field>
                              <label>
                                Company Zip/Postal
                                <i class="md-icon">help</i>
                              </label>
                              <md-input v-model="companyZip" type="number"></md-input>
                            </md-field>
                          </div>
                          <div class="md-layout-item md-small-size-100 md-size-100 p-4">
                            <div class="md-card-avatar">
                              <label class="company_logo_label">
                                Company Logo
                                <i class="md-icon">help</i>
                              </label>
                              <img class="img" alt="" :src="companyLogo" @click="$refs.compImgUpload.click()" />
                              <div class="edit-user-avatar" @click="$refs.compImgUpload.click()">
                                <md-icon class="dark-blue-back-ground-color-side-bar">edit</md-icon>
                              </div>
                              <input aria-label="Company logo" style="display: none" name="companyLogo" type="file"
                                @change="onCompanyChange" ref="compImgUpload" />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="text-right saveBtn">
                        <md-button @click="tabType = 'My Company'" type="submit"
                          class="md-raised md-info md-round mt-4 dark-blue-color">Save Changes</md-button>
                      </div>
                    </md-card-content>
                  </md-card>
                </md-tab>
                <md-tab id="settings" md-label="Settings" class="p-0">
                  <md-card class="account_info">
                    <h2>Settings</h2>
                    <md-card-content>
                      <div class="form_Wrapper">
                        <div class="md-layout right_section">
                          <div class="md-layout-item md-small-size-100 md-size-100">
                            <div class="section-title my-2">Preferences</div>
                          </div>
                          <div class="md-layout-item md-small-size-100 md-size-50">
                            <md-field :class="{ 'md-invalid': $v.defaultScreen.$error }">
                              <label for="default-screen">
                                Default Screen
                                <i class="md-icon">help</i>
                              </label>
                              <md-select id="default-screen" v-model="$v.defaultScreen.$model" name="defaultScreen">
                                <md-option v-for="defaultScreen in defaultScreens" :key="defaultScreen.path"
                                  :value="defaultScreen.path">{{ defaultScreen.name }}</md-option>
                              </md-select>
                              <span class="md-error" v-if="!$v.defaultScreen.required">This field is required.</span>
                            </md-field>
                          </div>
                          <div class="md-layout-item md-small-size-100 md-size-50">
                            <md-field :class="{ 'md-invalid': $v.dateFormat.$error }">
                              <label for="date-format">Date Format</label>
                              <md-select id="date-format" v-model="dateFormat" name="dateFormat">
                                <md-option v-for="dateFormat in dateFormats" :key="dateFormat" :value="dateFormat">{{
                                  dateFormat }}</md-option>
                              </md-select>
                              <span class="md-error" v-if="!$v.dateFormat.required">This field is required.</span>
                            </md-field>
                          </div>
                          <div class="md-layout-item md-small-size-100 md-size-50">
                            <md-field :class="{ 'md-invalid': $v.timeFormat.$error }">
                              <label for="time-format">Time Format</label>
                              <md-select id="time-format" v-model="$v.timeFormat.$model" name="timeFormat">
                                <md-option v-for="timeFormat in timeFormats" :key="timeFormat" :value="timeFormat">{{
                                  timeFormat }}</md-option>
                              </md-select>
                              <span class="md-error" v-if="!$v.timeFormat.required">This field is required.</span>
                            </md-field>
                          </div>
                          <div class="md-layout-item md-small-size-100 md-size-50">
                            <md-field :class="{ 'md-invalid': $v.timeZone.$error }">
                              <label for="time-zone">Time Zone</label>
                              <md-select id="time-zone" v-model="$v.timeZone.$model" name="timeFormat">
                                <md-option v-for="timeZone in timeZones" :key="timeZone.name" :value="timeZone.name">{{
                                  timeZone.Description }}/{{
    timeZone.GMT
  }}</md-option>
                              </md-select>
                              <span class="md-error" v-if="!$v.timeZone.required">This field is required.</span>
                            </md-field>
                          </div>
                          <div class="md-layout-item md-small-size-100 md-size-50">
                            <md-field :class="{ 'md-invalid': $v.industry.$error }">
                              <label for="my-industry">My Industry</label>
                              <md-select id="my-industry" v-model="$v.industry.$model" name="timeFormat">
                                <md-option v-for="industry in industries" :key="industry.label" :value="industry.label">
                                  {{ industry.label }}</md-option>
                              </md-select>
                              <span class="md-error" v-if="!$v.industry.required">This field is required.</span>
                            </md-field>
                          </div>
                          <div class="md-layout-item md-small-size-100 md-size-50">
                            <md-field :class="{ 'md-invalid': $v.myTitle.$error }">
                              <label for="my-title">My Title</label>
                              <md-select id="my-title" v-model="$v.myTitle.$model">
                                <md-option v-for="myTitle in myTitles" :key="myTitle.label" :value="myTitle.label">{{
                                  myTitle.label }}</md-option>
                              </md-select>
                              <span class="md-error" v-if="!$v.myTitle.required">This field is required.</span>
                            </md-field>
                          </div>
                          <div class="md-layout-item md-small-size-100 md-size-50">
                            <md-field>
                              <label for="pdf-downloading">PDF Downloading</label>
                              <md-select id="pdf-downloading" v-model="$v.pdfDownloading.$model">
                                <md-option v-for="pdfDownItem in pdfDownloadOptions" :key="pdfDownItem.label"
                                  :value="pdfDownItem.label">{{ pdfDownItem.label }}</md-option>
                              </md-select>
                              <span class="md-error" v-if="!$v.pdfDownloading.required">This field is required.</span>
                            </md-field>
                          </div>
                        </div>
                      </div>
                      <div class="text-right saveBtn">
                        <md-button @click="tabType = 'Settings'" type="submit"
                          class="md-raised md-info md-round mt-4 dark-blue-color">
                          Save Changes</md-button>
                      </div>
                    </md-card-content>
                  </md-card>
                </md-tab>
                <md-tab id="billing" md-label="Billing" class="p-0">
                  <md-card class="account_info">
                    <h3>Billing and Invoices</h3>
                    <md-card-content>
                      <Billing />
                    </md-card-content>
                  </md-card>
                </md-tab>
                <md-tab id="ac-activity" md-label="Account Activity" class="p-0">
                  <md-card class="account_info">
                    <h2>Account Activity</h2>
                    <md-card-content class="px-4">
                      <div class="billing_sec acc_activity">
                        <table-card>
                          <template slot="header">
                            <h3 class="title title-color-white">My Usage</h3>
                          </template>
                          <template slot="content">
                            <div class="md-layout md-alignment-center">
                              <div
                                class="md-layout-item product-accessed md-medium-size-100 md-xsmall-size-100 md-size-25 px-4">
                                <chart-card v-if="this.hasSubscriptionsData
                                  " header-animation="false" :chart-data="productsAccessed.data"
                                  :chart-options="productsAccessed.options" chart-type="Pie" header-icon
                                  chart-inside-content :chart-primary-number="this.getAvailableReports()
                                    " chart-primary-color="#3b7ef1">
                                  <template slot="footer">
                                    <div class="md-layout">
                                      <div class="md-layout-item md-size-100">
                                        <h3 class="category text-center">
                                          My Profile/Report credits available
                                        </h3>
                                      </div>
                                      <div class="md-layout-item text-center">
                                        <h4 v-if="this.subscriptionsData
                                            .reportLimit == 9999
                                          ">
                                          UNLIMITED
                                        </h4>
                                        <h4 v-else>
                                          <span style="color: #3b7ef1">
                                            {{ this.getAvailableReports() }}
                                          </span>
                                          /{{
                                            this.subscriptionsData
                                              .reportLimit == 9999
                                            ? "UNLIMITED"
                                            : this.numberWithCommas(
                                              this.subscriptionsData
                                                .reportLimit
                                            )
                                          }}
                                        </h4>
                                      </div>
                                    </div>
                                  </template>
                                </chart-card>
                              </div>
                              <div
                                class="md-layout-item product-accessed md-medium-size-50 md-xsmall-size-100 md-size-25 px-4">
                                <chart-card v-if="!this.isRetail &&
                                    this.hasSubscriptionsData &&
                                    this.calculateDiffDays(
                                      Date.now(),
                                      this.subscriptionsData.expiration
                                    )
                                    " header-animation="false" :chart-data="daysLeft.data"
                                  :chart-options="daysLeft.options" chart-type="Pie" header-icon chart-inside-content
                                  :chart-primary-number="this.calculateDiffDays(
                                    Date.now(),
                                    this.subscriptionsData.expiration
                                  )
                                    " chart-primary-color="#f3a811">
                                  <template slot="footer">
                                    <div class="md-layout">
                                      <div class="md-layout-item md-size-100">
                                        <h4 class="category text-center">
                                          Days left
                                        </h4>
                                      </div>
                                      <div class="md-layout-item text-center">
                                        <h4 v-if="this.calculateDiffDays(
                                          Date.now(),
                                          this.subscriptionsData.expiration
                                        ) == 'Expired'
                                          ">
                                          Expired
                                        </h4>
                                        <h4 v-else>
                                          <span style="color: #f3a811">
                                            {{
                                              this.calculateDiffDays(
                                                Date.now(),
                                                this.subscriptionsData
                                                  .expiration
                                              )
                                            }}
                                          </span>
                                          /{{
                                            this.calculateDiffDays(
                                              this.subscriptionsData.start,
                                              this.subscriptionsData.expiration
                                            )
                                          }}
                                        </h4>
                                      </div>
                                    </div>
                                  </template>
                                </chart-card>
                              </div>
                              <div
                                class="md-layout-item product-accessed md-medium-size-50 md-xsmall-size-100 md-size-25 px-4">
                                <chart-card v-if="!this.isRetail && this.hasSubscriptionsData
                                    " header-animation="false" :chart-data="credits.data"
                                  :chart-options="credits.options" chart-type="Pie" header-icon chart-inside-content
                                  :chart-primary-number="!this.numberWithCommas(this.creditsTotal) ==
                                      9999
                                      ? 'Unlimited'
                                      : creditsAvailable
                                    " chart-primary-color="#7041e5">
                                  <template slot="footer">
                                    <div class="md-layout">
                                      <div class="md-layout-item md-size-100">
                                        <h4 class="category text-center">
                                          List credits available
                                        </h4>
                                      </div>
                                      <div class="md-layout-item text-center">
                                        <h4 v-if="this.numberWithCommas(
                                          this.creditsTotal
                                        ) == 9999
                                          ">
                                          UNLIMITED
                                        </h4>
                                        <h4 v-else>
                                          <span style="color: #7041e5">
                                            {{
                                              this.numberWithCommas(
                                                this.creditsAvailable
                                              )
                                            }}
                                          </span>
                                          /{{
                                            this.numberWithCommas(
                                              this.creditsTotal
                                            ) == 9999
                                            ? "UNLIMITED"
                                            : this.numberWithCommas(
                                              this.creditsTotal
                                            )
                                          }}
                                        </h4>
                                      </div>
                                    </div>
                                  </template>
                                </chart-card>
                              </div>
                              <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100 card-buttons">
                                <md-button class="md-info md-round">
                                  <a href="https://bizminer.pipedrive.com/scheduler/qllvp0s0/bizminer-account-upgrade" target="_blank"
                                    class="href-white dark-blue-color" @click="countUpdateAccountClick()">
                                    Upgrade Account
                                    <md-icon class="m-0">admin_panel_settings</md-icon>
                                  </a>
                                </md-button>
                              </div>
                            </div>
                          </template>
                        </table-card>
                      </div>
                      <AccountActivityTab :account="true" />
                    </md-card-content>
                  </md-card>
                </md-tab>
                <md-tab id="my_team" md-label="My Team" class="p-0">
                  <md-card class="account_info">
                    <h2>My Team</h2>
                    <md-card-content class="px-4">
                      <div class="billing_sec acc_activity">
                        <table-card>
                          <template slot="header">
                            <h3 class="title title-color-white">Team Usage</h3>
                          </template>
                          <template slot="content">
                            <div class="md-layout md-alignment-center">
                              <div
                                class="md-layout-item product-accessed md-medium-size-100 md-xsmall-size-100 md-size-25 px-4">
                                <chart-card v-if="!this.isRetail && this.hasSubscriptionsData
                                  " header-animation="false" :chart-data="productsAccessed.data"
                                  :chart-options="productsAccessed.options" chart-type="Pie" header-icon
                                  chart-inside-content :chart-primary-number="this.subscriptionsData
                                      .reportLimitOriginal == 9999
                                      ? 'Unlimited'
                                      : this.subscriptionsData
                                        .total_available_reports
                                    " chart-primary-color="#3b7ef1">
                                  <template slot="footer">
                                    <div class="md-layout">
                                      <div class="md-layout-item md-size-100">
                                        <h3 class="category text-center">
                                          Total Profile/Report Credits Available
                                        </h3>
                                      </div>
                                      <div class="md-layout-item text-center">
                                        <h4 v-if="this.subscriptionsData
                                            .reportLimitOriginal == 9999
                                          ">
                                          UNLIMITED
                                        </h4>
                                        <h4 v-else>
                                          <span style="color: #3b7ef1">
                                            {{
                                              this.subscriptionsData
                                                .total_available_reports
                                            }}
                                          </span>
                                          /{{
                                            this.subscriptionsData
                                              .reportLimitOriginal == 9999
                                            ? "UNLIMITED"
                                            : this.subscriptionsData
                                              .reportLimitOriginal
                                          }}
                                        </h4>
                                      </div>
                                    </div>
                                  </template>
                                </chart-card>
                              </div>
                              <div
                                class="md-layout-item product-accessed md-medium-size-50 md-xsmall-size-100 md-size-25 px-4">
                                <chart-card header-animation="false" :chart-data="daysLeft.data"
                                  :chart-options="daysLeft.options" chart-type="Pie" header-icon chart-inside-content
                                  :chart-primary-number="this.totalTeamMembers == 9999
                                      ? 'Unlimited'
                                      : this.totalActiveTeamMembers
                                    " chart-primary-color="#f3a811">
                                  <template slot="footer">
                                    <div class="md-layout">
                                      <div class="md-layout-item md-size-100">
                                        <h4 class="category text-center">
                                          Active Team Members
                                        </h4>
                                      </div>
                                      <div class="md-layout-item text-center">
                                        <h4 v-if="this.totalTeamMembers == 9999">
                                          UNLIMITED
                                        </h4>
                                        <h4 v-else>
                                          <span style="color: #f3a811">
                                            {{ this.totalActiveTeamMembers }}
                                          </span>
                                          /{{
                                            this.totalTeamMembers == 9999
                                            ? "UNLIMITED"
                                            : this.totalTeamMembers
                                          }}
                                        </h4>
                                      </div>
                                    </div>
                                  </template>
                                </chart-card>
                              </div>
                              <div v-if="!this.isRetail &&
                                  this.hasSubscriptionsData &&
                                  !this.subscriptionsData
                                    .reportLimitOriginal == 9999
                                  "
                                class="md-layout-item product-accessed md-medium-size-50 md-xsmall-size-100 md-size-25 px-4">
                                <chart-card header-animation="false" :chart-data="credits.data"
                                  :chart-options="credits.options" chart-type="Pie" header-icon chart-inside-content
                                  :chart-primary-number="this.subscriptionsData
                                      .reportLimitOriginal == 9999
                                      ? 'Unlimited'
                                      : this.numberWithCommas(
                                        this.subscriptionsData
                                          .total_distributed_reports
                                      )
                                    " chart-primary-color="#7041e5">
                                  <template slot="footer">
                                    <div class="md-layout">
                                      <div class="md-layout-item md-size-100">
                                        <h4 class="category text-center">
                                          Total Profile/Report Credits
                                          Distributed
                                        </h4>
                                      </div>
                                      <div class="md-layout-item text-center">
                                        <h4 v-if="this.subscriptionsData
                                            .reportLimitOriginal == 9999
                                          ">
                                          UNLIMITED
                                        </h4>
                                        <h4 v-else>
                                          <span style="color: #7041e5">
                                            {{
                                              this.numberWithCommas(
                                                this.subscriptionsData
                                                  .total_distributed_reports
                                              )
                                            }}
                                          </span>
                                          /{{
                                            this.subscriptionsData
                                              .reportLimitOriginal == 9999
                                            ? "UNLIMITED"
                                            : this.subscriptionsData
                                              .reportLimitOriginal
                                          }}
                                        </h4>
                                      </div>
                                    </div>
                                  </template>
                                </chart-card>
                              </div>
                              <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100 card-buttons">
                                <md-button class="md-info md-round">
                                  <a href="" target="_blank" class="href-white dark-blue-color">
                                    Upgrade Account
                                    <md-icon class="m-0">admin_panel_settings</md-icon>
                                  </a>
                                </md-button>
                              </div>
                            </div>
                          </template>
                        </table-card>
                      </div>
                      <ManageTeamTab :confirmation="this.confirmation" />
                      <AccountActivityTab :account="null" />
                    </md-card-content>
                  </md-card>
                </md-tab>
                <md-tab id="reset_password" md-label="Reset Password" class="p-0">
                  <md-card class="account_info">
                    <h2>Reset Password</h2>
                    <md-card-content class="px-4">
                      <div class="billing_sec acc_activity">
                        <table-card>
                          <template slot="header">
                            <h3 class="title title-color-white">
                              New Password
                            </h3>
                            <!-- <md-button class="md-round" @click="reset()">
                              <md-icon class="ml-5">lock_reset</md-icon>Reset
                            </md-button> -->
                          </template>
                          <template slot="content">
                            <div class="md-layout">
                              <div class="md-layout-item px-4">
                                <form @submit.prevent="sendPasswordReset">
                                  <div class="form_Wrapper">
                                    <div class="md-layout">
                                      <div class="md-layout-item md-small-size-100 md-size-100">
                                        <md-field>
                                          <label>
                                            Current Password
                                            <!-- <i class="md-icon">help</i> -->
                                          </label>
                                          <md-input v-model="$v.current_password.$model" type="password" />
                                          <span class="md-error" v-if="!$v.current_password.required">
                                            This field is required
                                          </span>
                                        </md-field>
                                      </div>
                                      <div class="md-layout-item md-small-size-100 md-size-50">
                                        <md-field>
                                          <label>
                                            New Password
                                            <!-- <i class="md-icon">help</i> -->
                                          </label>
                                          <md-input v-model="$v.reset_password.$model" type="password" />
                                          <span class="md-error" v-if="!$v.reset_password.required">
                                            This field is required
                                          </span>
                                        </md-field>
                                      </div>
                                      <div class="md-layout-item md-small-size-100 md-size-50">
                                        <md-field>
                                          <label>
                                            Confirm Password
                                            <!-- <i class="md-icon">help</i> -->
                                          </label>
                                          <md-input v-model="$v.reset_password_confirmation
                                              .$model
                                            " type="password" />
                                          <span class="md-error" v-if="!$v.reset_password_confirmation
                                              .required
                                            ">
                                            This field is required
                                          </span>
                                          <span class="md-error" v-if="!$v.reset_password_confirmation
                                              .sameAsPassword
                                            " style="bottom: -20px">
                                            Passwords must be identical
                                          </span>
                                        </md-field>
                                      </div>
                                      <div class="button-container">
                                        <!-- <md-button
                                            class="md-info md-round"
                                            type="submit"
                                            slot="footer"
                                          >
                                            Send
                                          </md-button> -->
                                        <div class="md-layout-item md-size-100 text-right">
                                          <md-button @click="tabType = 'My Team'" type="submit"
                                            class="md-raised md-info md-round mt-4 dark-blue-color">Save
                                            Changes</md-button>
                                        </div>
                                      </div>
                                    </div>
                                  </div>

                                  <!-- </login-card> -->
                                </form>
                              </div>
                            </div>
                          </template>
                        </table-card>
                      </div>
                    </md-card-content>
                  </md-card>
                </md-tab>
              </md-tabs>
            </template>
          </nav-tabs-card>
        </div>
      </div>
    </form>
    <modal class="addTeam" v-if="$store.getters['showNewTeamModal']" @close="closeNewTeamModal()">
      <template slot="header">
        <h4 class="modal-title">Add New Team Member</h4>
        <button type="button" class="close_btn" @click="closeNewTeamModal()">
          <md-icon>clear</md-icon>
        </button>
      </template>
      <template slot="body">
        <div class="field-wrap">
          <md-field>
            <label>First Name*</label>
            <md-input type="text" v-model="newMemberData.firstName"></md-input>
          </md-field>
          <md-field>
            <label>Last Name*</label>
            <md-input type="text" v-model="newMemberData.lastName"></md-input>
          </md-field>
          <md-field>
            <label>Email*</label>
            <md-input type="email" v-model="newMemberData.email"></md-input>
          </md-field>
          <md-field>
            <label>Credits</label>
            <md-input type="text" v-model="newMemberData.reportLimit"></md-input>
          </md-field>
        </div>
      </template>
      <template slot="footer">
        <md-button class="md-info md-round md-theme-default" @click="addNewTeamMember()">
          <md-icon class="ml-5">person_add</md-icon>Add Member
        </md-button>
        <md-button class="md-info md-round md-danger md-simple" @click="closeNewTeamModal()">Close</md-button>
      </template>
    </modal>
    <modal class="addTeam" v-if="$store.getters['showUpdateTeamModal']" @close="closeUpdateTeamModal()">
      <template slot="header">
        <h4 class="modal-title">Update Team Member</h4>
        <button type="button" class="close_btn" @click="closeUpdateTeamModal()">
          <md-icon>clear</md-icon>
        </button>
      </template>
      <template slot="body">
        <div class="field-wrap">
          <md-field>
            <label>First Name*</label>
            <md-input type="text" v-model="updateMemberData.firstName"></md-input>
          </md-field>
          <md-field>
            <label>Last Name*</label>
            <md-input type="text" v-model="updateMemberData.lastName"></md-input>
          </md-field>
          <md-field>
            <label>Email*</label>
            <md-input type="email" v-model="updateMemberData.email"></md-input>
          </md-field>
          <md-field>
            <label>Credits</label>
            <md-input type="text" v-model="updateMemberData.limit"></md-input>
          </md-field>
        </div>
      </template>
      <template slot="footer">
        <md-button class="md-info md-round md-theme-default" @click="updateTeamMember()">
          <md-icon class="ml-5">person_add</md-icon>Update Member
        </md-button>
        <md-button class="md-info md-round md-danger md-simple" @click="closeUpdateTeamModal()">Close</md-button>
      </template>
    </modal>
    <modal class="addTeam" v-if="$store.getters['confirmationModal']" @close="closeConfirmationModal()">
      <template slot="header">
        <h4 class="modal-title"></h4>
        <button type="button" class="close_btn" @click="closeConfirmationModal()">
          <md-icon>clear</md-icon>
        </button>
      </template>
      <template slot="body">
        <div class="field_wpr">
          Are you sure you want to {{ $store.getters["confirmationType"] }} this
          team member?
        </div>
      </template>
      <template slot="footer">
        <md-button class="md-info md-round md-theme-default" @click="confirmation = true">
          {{ $store.getters["confirmationType"] }}
        </md-button>
        <md-button class="md-info md-round md-danger md-simple" @click="closeConfirmationModal()">
          Cancel</md-button>
      </template>
    </modal>
  </div>
</template>

<script>
import Billing from "./UserProfile/BillingAndInvoices";
import AccountActivityTab from "./UserProfile/Subscriptions/_partials/AccountActivityTab";
import ManageTeamTab from "./UserProfile/Subscriptions/_partials/ManageTeamTab";
import {
  countryList,
  localStates,
  localTimeZones,
} from "@/assets/common/location";
import { required, email, sameAs } from "vuelidate/lib/validators";
import sha256 from "crypto-js/sha256";
import { mapActions } from "vuex";
// import PulseLoader from 'vue-spinner/src/PulseLoader.vue';
import {
  TableCard,
  ChartCard,
  NavTabsCard,
  Modal,
  PulseLoader,
} from "@/components";
import { mapState, mapGetters } from "vuex";
import Avatar from "vue-avatar";

export default {
  name: "user-profile",
  components: {
    Billing,
    AccountActivityTab,
    ManageTeamTab,
    TableCard,
    ChartCard,
    NavTabsCard,
    Modal,
    PulseLoader,
    Avatar,
  },
  props: {
    upgradebtn: Function,
    buttonColor: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      confirmation: false,
      tabType: null,
      showTooltip: false,
      loading: true,
      avatar: null,
      password: null,
      disabled: null,
      emailAddress: null,
      lastname: null,
      firstname: null,
      billingFirstname: null,
      billingLastname: null,
      billingemailAddress: null,
      phoneNumber: null,
      address: null,
      city: null,
      stateProvince: null,
      // country: null,
      code: null,
      defaultScreen: null,
      dateFormat: null,
      timeFormat: null,
      timeZone: null,
      defaultScreens: [
        { name: "Search", path: "Search" },
        { name: "New Industry Financial Profile", path: "NewProfile" },
        { name: "New Industry Market Profile", path: "NewMarketProfile" },
        { name: "New Company Profile", path: "FindCompanies" },
        { name: "New Company List", path: "ProspectList" },
        { name: "Benchmarking Tool", path: "NewReport" },
        { name: "Valuation Multiple", path: "ValuationMultiple" },
        { name: "My Data", path: "MyData" },
        { name: "Subscription Activity", path: "Subscriptions" },
      ],
      dateFormats: ["MM/DD/YYYY", "DD/MM/YYYY", "YYYY/MM/DD"],
      timeFormats: ["12h AM/PM", "24h"],
      industry: null,
      myTitle: null,
      countries: countryList,
      states: localStates,
      timeZones: localTimeZones,
      industries: null,
      companyName: null,
      companyAddress: null,
      companyCity: null,
      companyState: null,
      companyZip: null,
      companyCountry: null,
      companyLogo: null,
      myTitles: null,
      pdfDownloading: null,
      pdfDownloadOptions: [
        { label: "Open in new window" },
        { label: "Download automatically" },
      ],
      file: null,
      companyFile: null,
      newMemberData: {},
      updateMemberData: {},
      productsAccessed: {
        data: {
          series: [
            {
              value: 100,
              className: "secondary",
            },
          ],
        },
        options: {
          height: "180px",
          width: "180px",
          donut: true,
          donutWidth: 8,
          startAngle: 0,
          total: 100,
          showLabel: false,
        },
        num: 2828,
      },
      retailValue: {
        data: {
          series: [{ value: 100, className: "cyan" }],
        },
        options: {
          height: "180px",
          width: "180px",
          donut: true,
          donutWidth: 8,
          startAngle: 0,
          total: 100,
          showLabel: false,
        },
        retail_value: 704172,
      },
      daysLeft: {
        days_left: 730,
        total_days: 730,
        data: {
          series: [{ value: 278, className: "gold" }],
        },
        options: {
          height: "180px",
          width: "180px",
          donut: true,
          donutWidth: 8,
          startAngle: 0,
          total: this.total_days,
          showLabel: false,
        },
      },
      credits: {
        days_left: 278,
        total_days: 730,
        data: {
          series: [
            { value: 100, className: "purple-light" },
            //{ value: 452, className: 'purple-light' },
          ],
        },
        options: {
          height: "180px",
          width: "180px",
          donut: true,
          donutWidth: 8,
          startAngle: 0,
          total: this.total_days,
          showLabel: false,
        },
      },
      country: "",
      region: "",
      current_password: null,
      reset_password: null,
      reset_password_confirmation: null,
    };
  },
  validations: {
    emailAddress: {
      required,
      email,
    },
    firstname: {
      required,
    },
    lastname: {
      required,
    },
    billingFirstname: {
      required,
    },
    billingLastname: {
      required,
    },
    billingemailAddress: {
      required,
      email,
    },
    phoneNumber: {
      required,
    },
    address: {
      required,
    },
    city: {
      required,
    },
    stateProvince: {
      required,
    },
    country: {
      required,
    },
    code: {
      required,
    },
    defaultScreen: {
      required,
    },
    dateFormat: {
      required,
    },
    timeFormat: {
      required,
    },
    timeZone: {
      required,
    },
    defaultScreens: {
      required,
    },
    dateFormats: {
      required,
    },
    timeFormats: {
      required,
    },
    industry: {
      required,
    },
    myTitle: {
      required,
    },
    pdfDownloading: {
      required,
    },
    current_password: {
      required,
    },
    reset_password: {
      required,
    },
    reset_password_confirmation: {
      required,
      sameAsPassword: sameAs("reset_password"),
    },
  },
  computed: {
    ...mapState({
      auth_user: (state) => state.user,
      setDefaultScreen: (state) =>
        state?.user?.user?.preferences?.defaultScreen,
      isRetail: (state) =>
        state.user.user_type.retail /*|| state.user.allow_retail*/ ? true : null,
      isEnterprise: (state) => state.user.user_type.enterprise ?? null,
      isSubscriber: (state) => state.user.user_type.subscriber ?? null,
      userType: (state) => state.user.user_type ?? null,
      subscriptions: (state) => state?.user?.user_subscriptions,
      subscriptionsData: (state) => state?.user?.user_subscriptionsData ?? {},
      creditsAvailable: (state) => state.prospectSearch.psCreditsAvailable,
      creditsTotal: (state) => state.prospectSearch.psCreditsTotal,
      creditsUsed: (state) => state.prospectSearch.psCreditsUsed,
      is_sub_user: (state) => state?.user?.user?.is_sub_user,
      totalTeamMembers: (state) => state?.user?.totalTeamMembers,
      totalActiveTeamMembers: (state) => state?.user?.totalActiveTeamMembers,
      authPromise: (state) => state?.auth?.authData,
    }),
    ...mapGetters(["updateTeamMemberDetails"]),
    hasSubscriptionsData() {
      return Object.keys(this.subscriptionsData).length > 0;
    },
  },
  watch: {
    updateTeamMemberDetails() {
      let details = this.$store.getters["updateTeamMemberDetails"];

      this.updateMemberData = {
        firstName: details.firstName,
        lastName: details.lastName,
        email: details.email,
        member_id: details.id,
        reportLimit: details.limit ? parseInt(details.limit) : null,
        limit: details.limit ? parseInt(details.limit) : null,
      };
    },
  },
  methods: {
    getAvailableReports: function () {
      if (!this.hasSubscriptionsData) return 0;
      if (this.subscriptionsData.reportLimit == 9999) return "Unlimited";
      if (
        this.subscriptionsData.reportLimit !==
        this.subscriptionsData.reportLimitOriginal
      )
        return (
          this.subscriptionsData.reportLimit -
          this.subscriptionsData.total_parent_usage
        );

      return this.subscriptionsData.total_available_reports;
    },
    upgrade_btn: function () {
      document.querySelector(".main-navbar .upgrade button").click();
    },
    ...mapActions({
      saveUserProfile: "profile/save",
      alertSuccess: "alerts/success",
      alertError: "alerts/error",
      countUpdateAccount: "tracking/countUpdateAccount",
    }),
    countUpdateAccountClick() {
      this.countUpdateAccount({ userId: this.auth_user?.user?.userID });
    },
    checkCountry: function (country) {

      let countryModel = country ? country
        .toUpperCase()
        .replace(/[^a-zA-Zs]/g, "")
        .replace(/\s/g, "") : null;
      if (countryModel == "UNITEDSTATES") return "US";

      return countryModel;
    },
    calculateDiffDays(date1Aux, date2Aux) {
      var date1 = new Date(date1Aux);
      var date2 = new Date(date2Aux);

      let result = (date2.getTime() - date1.getTime()) / (1000 * 3600 * 24);
      return result < 0 ? "Expired" : Math.ceil(result);
    },
    async saveAll(event) {
      event.preventDefault();
      this.$v.$touch();

      let profileInfo = null;
      let auxURL = null;

      if (this.tabType === "My Profile") {
        // if (!(this.file && this.firstname && this.lastname && this.emailAddress && this.billingFirstname && this.billingLastname
        //   && this.billingemailAddress && this.phoneNumber && this.address && this.city && this.stateProvince && this.code && this.country
        // ))
        //   return;
        auxURL = "_my_profile";
        profileInfo = {
          avatar: this.file ?? '',
          accountFirst: this.firstname ?? '',
          accountLast: this.lastname ?? '',
          accountEmail: this.emailAddress ?? '',
          billingFirst: this.billingFirstname ?? '',
          billingLast: this.billingLastname ?? '',
          billingEmail: this.billingemailAddress ?? '',
          phoneNumber: this.phoneNumber ?? '',
          streetAddr: this.address ?? '',
          city: this.city ?? '',
          state: this.stateProvince ?? '',
          zip: this.code ?? '',
          country: this.country ?? '',
        };
      } else if (this.tabType === "My Company") {
        auxURL = "_my_company";
        profileInfo = {
          avatar: this.file ?? '',
          companyName: this.companyName ?? '',
          companyAddress: this.companyAddress ?? '',
          companyCity: this.companyCity ?? '',
          companyState: this.companyState ?? '',
          companyZip: this.companyZip ?? '',
          companyCountry: this.companyCountry ?? '',
          companyLogo: this.companyFile ?? '',
        };
      } else if (this.tabType === "Settings") {
        auxURL = "_settings";
        profileInfo = {
          prefDefaultScreen: this.defaultScreen ?? '',
          prefDateFormat: this.dateFormat ?? '',
          prefTimeFormat: this.timeFormat ?? '',
          prefTimezone: this.timeZone ?? '',
          prefIndustry: this.industry ?? '',
          prefTitle: this.myTitle ?? '',
          pdfDownloading: this.pdfDownloading ?? '',
        };
      } else if (this.tabType === "MyTeam") return;

      if (this.password) {
        profileInfo.password = sha256(this.password).toString();
      }

      let params = new FormData();
      let g = Object.keys(profileInfo);
      let b = Object.values(profileInfo);
      g.forEach((element, index) => {
        params.append(element, b[index]);
      });

      await this.$store.dispatch("profile/save", { params, auxURL });
      //this.getAuth();
    },
    getClass: function (headerColor) {
      return "md-card-header-" + headerColor + "";
    },
    childToParent: function (inputType) {
      this.$emit("changeParent", this[inputType]);
    },
    async getAuth() {
      try {
        this.$store.dispatch("authenticateUser").then((res) => {
          if (res && res.hasOwnProperty("data") && res.data.error) {
            this.$store.commit("SET_ERROR_BIT", true);
            this.$store.commit(
              "SET_ERROR_INFO",
              "<br>" +
              "Server responded with error = True <br> errorCode: " +
              res.data.errorCode
            );
            throw new Error(
              "<br>" +
              "Server responded with error = True <br> errorCode: " +
              res.data.errorCode
            );
          }
          /*if(!res)
            this.$router.go();
          */
          if (!res) {
            res = this.authPromise;
            if (!res)
              this.$router.go();
          }


          this.firstname = res.firstName;
          this.lastname = res.lastName;
          this.billingFirstname = res.firstNameBilling;
          this.billingLastname = res.lastNameBilling;
          this.emailAddress = res.email;
          this.billingemailAddress = res.emailBilling;
          this.phoneNumber = res.phoneNumber;
          this.address = res.streetAddr;
          this.city = res.city;
          this.stateProvince = res.state;
          this.code = res.zip;
          this.country = this.checkCountry(res.country);
          this.defaultScreen = res.preferences.defaultScreen
            ? res.preferences.defaultScreen
            : "Search";
          this.dateFormat = res.preferences.dateFormat
            ? res.preferences.dateFormat
            : "MM/DD/YYYY";
          this.timeFormat = res.preferences.timeFormat
            ? res.preferences.timeFormat
            : "12h AM/PM";
          this.timeZone = res.preferences.timezone
            ? res.preferences.timezone
            : "EST";
          this.industry = res.preferences.industry;
          this.myTitle = res.preferences.title;
          this.pdfDownloading = res.preferences.defaultPDFDownload;
          this.companyName = res.companyName;
          this.companyAddress = res.companyAddress;
          this.companyCity = res.companyCity;
          this.companyState = res.companyState;
          this.companyZip = res.companyZip;
          this.companyCountry = res.companyCountry;
          this.avatar = res.avatar ? res.avatar : "";
          this.companyLogo = res.companyLogo ? res.companyLogo : "";
          this.$store.commit("user/SET_USER", res, { root: true });
          this.$store.commit("user/SET_HOME", res.preferences.defaultScreen);

          setTimeout(() => {
            this.loading = false;
          }, 300);


        });
      } catch (e) {
        this.$store.dispatch("alerts/error", "We can't get data for this user");
      }
    },
    onFileChange(event) {
      let files = event.target.files || event.dataTransfer.files;
      if (!files.length) return;
      this.createImage(files[0]);
    },
    onCompanyChange(event) {
      let files = event.target.files || event.dataTransfer.files;
      if (!files.length) return;
      this.createCompanyImage(files[0]);
    },
    createImage(file) {
      let reader = new FileReader();
      reader.onload = (e) => {
        this.avatar = e.target.result;
        this.file = file;
      };
      reader.readAsDataURL(file);
    },
    createCompanyImage(file) {
      let reader = new FileReader();
      reader.onload = (e) => {
        this.companyLogo = e.target.result;
        this.companyFile = file;
      };
      reader.readAsDataURL(file);
    },

    getGeneralInfo() {
      try {
        this.$store.dispatch("profile/getGenInfo").then((res) => {
          if (res.hasOwnProperty("data") && res.data.error) {
            this.$store.commit("SET_ERROR_BIT", true);
            this.$store.commit(
              "SET_ERROR_INFO",
              "<br>" +
              "Server responded with error = True <br> errorCode: " +
              res.data.errorCode
            );
            throw new Error(
              "<br>" +
              "Server responded with error = True <br> errorCode: " +
              res.data.errorCode
            );
          }
          this.industries = res.job_functions;
          this.myTitles = res.title_codes;
        });
      } catch (e) { }
    },
    closeNewTeamModal() {
      this.$store.commit("SET_SHOW_NEW_TEAM_MODAL", false);
    },
    closeUpdateTeamModal() {
      this.$store.commit("SET_SHOW_UPDATE_TEAM_MODAL", false);
    },
    closeConfirmationModal() {
      this.$store.commit("SET_CONFIRMATION_MODAL", false);
      this.confirmation = false;
    },
    async addNewTeamMember() {
      let currentSession = localStorage.getItem(
        "vue-authenticate.vueauth_access_token"
      );
      if ((this.newMemberData.limit = "")) this.newMemberData.limit = null;

      let params = this.newMemberData;
      params.username = "";
      params.session_id = currentSession;

      await this.$store.dispatch("team/add", params).then((res) => {
        this.$store.dispatch("alerts/success", "Team member added.");
        this.closeNewTeamModal();

        this.$store.commit("SET_UPDATE_TEAM_MEMBER_DETAILS", {});
      });
      this.newMemberData.firstName = null;
      this.newMemberData.lastName = null;
      this.newMemberData.email = null;
      this.newMemberData.reportLimit = null;
    },
    async updateTeamMember() {
      let currentSession = localStorage.getItem(
        "vue-authenticate.vueauth_access_token"
      );
      this.updateMemberData.reportLimit = parseInt(this.updateMemberData.limit);
      let params = this.updateMemberData;
      params.username = "";
      params.session_id = currentSession;

      await this.$store.dispatch("team/edit", params).then((res) => {
        this.$store.dispatch("alerts/success", "Team member updated.");
        this.closeUpdateTeamModal();
        this.$store.commit("SET_UPDATE_TEAM_MEMBER_DETAILS", {});
      });
    },
    async reset() {
      let currentSession = localStorage.getItem(
        "vue-authenticate.vueauth_access_token"
      );
      this.$v.$touch();
      if (this.$v.$invalid) {
        await this.$store.dispatch("alerts/error", "Please enter inputs!");
        return false;
      } else {
        this.$store.dispatch("getRandomString", 20).then(async (res) => {
          const user = {
            session_id: currentSession,
            email: this.emailAddress,
          };
          const requestOptions = {
            headers: {
              Accept: "application/vnd.api+json",
              "Content-Type": "application/vnd.api+json",
            },
          };

          try {
            await this.$store.dispatch("passwordReminder", {
              user,
              requestOptions,
            });
          } catch (e) {
            await this.$store.dispatch("alerts/error", "Invalid credentials!");
          }
        });
      }
    },
    numberWithCommas(x) {
      if (x !== undefined)
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      else x;
    },
    disabledContent(type) {
      let arrayTabs = document.getElementsByClassName(
        "md-button md-tab-nav-button md-theme-default"
      );

      for (let i = 0; i < arrayTabs.length; i++) {
        if (this.checkText(arrayTabs[i].innerText, type)) {
          arrayTabs[i].classList.add("non-subscriber");
          arrayTabs[i].classList.add("no-click");
        }
      }
    },
    checkText(text, type) {
      if (this.is_sub_user) {
        if (
          text.includes("Billing") ||
          text.includes("My Team") ||
          text.includes("My Company")
        )
          return true;
      }
      if (type === "retail") {
        if (
          text.includes("Settings") ||
          text.includes("My Team") ||
          text.includes("My Company")
        )
          return true;
      } else if (type === "enterprise") {
        if (text.includes("My Team")) return true;
      } else if (type === "report") {
        if (text.includes("My Company")) return true;
      }

      return false;
    },
    checkReportAccess() {
      if (
        this.subscriptions.includes("vpro") ||
        this.subscriptions.includes("swot") ||
        this.subscriptions.includes("lmr") ||
        this.subscriptions.includes("usmr") ||
        this.subscriptions.includes("mf") ||
        this.subscriptions.includes("usif") ||
        this.subscriptions.includes("lif")
      )
        return true;

      return false;
    },

    async sendPasswordReset() {
      if (this.$v.current_password.$invalid) {
        await this.$store.dispatch(
          "alerts/error",
          "Current password is required!"
        );
        return;
      }
      if (this.$v.reset_password.$invalid) {
        await this.$store.dispatch("alerts/error", "New password is required!");
        return;
      }
      if (this.$v.reset_password_confirmation.$invalid) {
        await this.$store.dispatch(
          "alerts/error",
          "New password confirmation is required!"
        );
        return;
      }

      this.$store
        .dispatch("recoverPasswordLoggedIn", {
          current_password: sha256(this.current_password).toString(),
          new_password: sha256(this.reset_password).toString(),
        })
        .then(async (res) => { });
    },
  },
  updated() {
    if (this.isRetail) this.disabledContent("retail");

    if (this.isSubscriber && !this.isEnterprise)
      this.disabledContent("enterprise");

    if (this.isSubscriber && this.checkReportAccess()) {
      this.disabledContent("report");
    } else {
      if (!this.isEnterprise && this.is_sub_user) {
        this.disabledContent("report");
      }
    }
  },
  async mounted() {
    await this.getAuth();
    if (this.isRetail) this.disabledContent("retail");

    if (this.isSubscriber && !this.isEnterprise)
      this.disabledContent("enterprise");

    if (this.isSubscriber && this.checkReportAccess()) {
      this.disabledContent("report");
    } else {
      if (!this.isEnterprise && this.is_sub_user) {
        this.disabledContent("report");
      }
    }
  },
  created() {
    this.getGeneralInfo();
  },
};
</script>
<style lang="scss">
.text-right {
  display: flex;
}

.my_account {
  .md-card-avatar {
    img {
      max-width: 150px;
      max-height: 150px;
    }
  }
}

.company_info {
  .section-title {
    font-size: 22px;
    line-height: 28px;
    color: #3b7ef1;
    font-weight: 600;
    margin-top: 30px;
    margin-bottom: 10px;
  }

  label {
    font-size: 13px !important;
    line-height: 16px;
    color: #133a64 !important;
    font-weight: 600;
    text-transform: capitalize;
    margin-bottom: 5px;
    display: inline-block;
    position: static;
    text-align: left;

    i {
      font-size: 16px !important;
      margin-left: 2px;
      height: 17px;
      vertical-align: bottom;
    }
  }

  .md-input {
    border: 1px solid #d9d9d9;
    padding: 0 15px;
    width: 100%;
    height: 40px;
    font-size: 14px;
    -webkit-box-flex: 0;
    -ms-flex: none;
    flex: none;
  }

  .md-field {
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
  }

  .company_logo_label {
    font-size: 13px !important;
    line-height: 16px;
    color: #133a64 !important;
    font-weight: 600;
    text-transform: capitalize;
    margin-bottom: 5px;
    display: inline-block;
    position: static;
    text-align: left;
  }

  .company_state,
  .company_country {
    input {
      border-right: none;
    }

    i {
      margin-bottom: 0 !important;
      border-top: 1px solid #d9d9d9;
      border-right: 1px solid #d9d9d9;
      height: 40px;
    }
  }
}

.md-field select {
  border-radius: 0px;
  margin-left: 0px;
  width: 100% !important;
}

.forgot-pass-link {
  display: block;
  font-size: 15px;
  line-height: 18px;
  font-weight: 600;
  text-align: center;
}

.product-accessed {
  max-width: 100% !important;
  flex: inherit !important;
}

.my_account .md-card-content .md-tabs .md-tabs-content .account_info .md-card-header .md-card-avatar {
  background-color: #6284a3 !important;
}

.my_account .md-card-content .md-tabs .md-tabs-navigation .md-button.md-tab-nav-button.md-active .md-ripple {
  background-color: #083464 !important;
}

.my_account .md-card-content .md-tabs .md-tabs-navigation .md-button.md-tab-nav-button:after {
  border-left: 30px solid #083464 !important;
}

.my_account .md-card-content .md-tabs .md-tabs-content .account_info .md-card-content .section-title,
.billing_sec .md-card-table .md-card-header .md-button .md-ripple .md-button-content .md-icon {
  color: #002277 !important;
}

.account_info>h2,
#billing>div>h3 {
  font-size: 30px;
  line-height: 36px;
  margin: 15px;
  color: #003666;
  font-weight: 600;
}

.billing_sec .md-card-table .md-card-content .billing-and-invoices-table table .md-table-cell .md-table-cell-container {
  color: black !important;
}
</style>
